import type { SignedUploadHandle, SyncTransport } from "@relais/offline";
import type {
  SyncFlushResponse,
  SyncMutation,
  TaskListItem,
} from "@relais/contracts";
import { apiFetch } from "./api.js";

export const apiSyncTransport: SyncTransport = {
  async flush(mutations: SyncMutation[]) {
    const r = await apiFetch<SyncFlushResponse>("/sync/flush", {
      method: "POST",
      body: JSON.stringify({ mutations }),
    });
    return { results: r.results.map((res) => res) };
  },

  async fetchTasks(since?: string) {
    const qs = since ? `?since=${encodeURIComponent(since)}` : "";
    return apiFetch<TaskListItem[]>(`/tasks${qs}`);
  },

  async createSignedUpload(taskId, clientId, ext) {
    return apiFetch<SignedUploadHandle>(
      `/tasks/${taskId}/medias/signed-upload`,
      {
        method: "POST",
        body: JSON.stringify({ client_id: clientId, ext }),
      },
    );
  },

  async uploadBlob(signedUrl, blob, mimeType) {
    const res = await fetch(signedUrl, {
      method: "PUT",
      headers: { "Content-Type": mimeType },
      body: blob,
    });
    if (!res.ok) {
      const detail = await res.text().catch(() => "");
      throw new Error(`storage_upload_failed_${res.status}: ${detail.slice(0, 200)}`);
    }
  },

  async fetchCatalogue(name: string) {
    return apiFetch<{
      name: string;
      version: string;
      fetchedAt: string;
      options: unknown[];
    }>(`/catalogues/${encodeURIComponent(name)}`);
  },
};
